import {redirect} from "react-router-dom"

import {getToken} from "../utilities/useToken"

// Surveys are hidden from the regular Administrator UI; only an
// Enterprise Admin may reach the routes directly.
export const checkSurveysAccess = () => {
    const {role} = getToken(true) || {}
    if (role === "Enterprise Admin") {
        redirect("/home")
    }

    return true
}
